import api from "@Core/Apis/api";
import apipaths from "@Core/Apis/apiPaths";
import { set, get} from "@Core/LocalStorage";
import CommonFunction from "@Core/Components/CommonFunction";

const CommonAction = {
  GetCaptcha: function (data, cb) {
    return (dispatch) => {
      api.setMethod("post").sendRequest(apipaths.GetCaptcha, data, true, function (response) {
        cb && cb(response.data)
      },
        dispatch
      );
    };
  },
  ValidateLink : function (data, cb) {
    return (dispatch) => {
      api.setMethod("post").sendRequest(apipaths.ValidateLink , data, true, function (response) {
        cb && cb(response.data)
      },
        dispatch
      );
    };
  },
  ValidateUserToken: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("post").setAuthToken(token).sendRequest(apipaths.ValidateUserToken, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  SendOTP: function (data, cb) {
    return (dispatch) => {
      api.setMethod("post").sendRequest(apipaths.SendOTP, data, true, function (response) {
        if (response.data && response.data.message == "Success" && response.data.statusCode == "200") {
          CommonFunction.updateSrmwuiCustomerObj('userData', response.data.data)
          }
        cb && cb(response.data)
      },
        dispatch
      );
    };
  },
  ValidateOTP: function (data, cb) {
    return (dispatch) => {
      api.setMethod("post").sendRequest(apipaths.ValidateOTP, data, true, function (response) {
        if (response.data && response.data.message == "Success" && response.data.statusCode == "200") {
          CommonFunction.updateSrmwuiCustomerObj('userToken', response.data && response.data.data && response.data.data.userToken)
          CommonFunction.updateSrmwuiCustomerObj('smartClubPoints', response.data && response.data.data && response.data.data.balancePoint)
          CommonFunction.updateSrmwuiCustomerObj('displayMessage', response.data && response.data.data && response.data.data.displayMessage)
          CommonFunction.updateSrmwuiCustomerObj('validTo', response.data && response.data.data && response.data.data.validTo)
          dispatch(CommonAction.setUserToken(response.data && response.data.data && response.data.data.userToken));
          dispatch(CommonAction.setLoggedIn(true));
        }
        cb && cb(response.data)
      },
        dispatch
      );
    };
  },
  Enrollment: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("post").setAuthToken(token).sendRequest(apipaths.Enrollment, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  MemberMigration: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("post").setAuthToken(token).sendRequest(apipaths.MemberMigration, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  RewardEnrollment: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("post").setAuthToken(token).sendRequest(apipaths.RewardEnrollment, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  SSOConfiguration: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("post").setAuthToken(token).sendRequest(apipaths.SSOConfiguration, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  Logout: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("post").setAuthToken(token).sendRequest(apipaths.Logout, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  ValidateToken: function (token, data, cb) {
    return (dispatch) => {
      api.setMethod("get").setAuthToken(token).sendRequest(apipaths.ValidateToken, data, true, function (response) {
        cb && cb(response)
      },
        dispatch
      );
    };
  },
  SetQueryperam: function (data) {
    return {
      type: "SetQueryperam",
      data,
    };
  },
  setLoggedIn: function (data) {
    return {
      type: "isLoggedIn",
      data,
    };
  },
  setUserToken: function (data) {
    return {
      type: "setUserToken",
      data,
    };
  },
  setSelectedMenue: function (data) {
    return {
      type: "setSelectedMenue",
      data,
    };
  },
  setLoading: function (data) {
    return {
      type: "setLoading",
      data,
    };
  },
  SetLoginFormData: function (data) {
    return {
      type: "SetLoginFormData",
      data,
    };
  },
    SetHomeData: function (data) {
    return {
      type: "SetHomeData",
      data,
    };
  },
  showLoader: function (data) {
    return {
      type: "showLoader",
      data,
    };
  },
  setLoaderData: function (data) {
    return {
      type: "setLoaderData",
      data,
    };
  },
  setRedirectLoader: function (data) {
    return {
      type: "setRedirectLoader",
      data,
    };
  },
};

export default CommonAction;
